module.exports = __webpack_public_path__ + "static/maj-britt-3-6ebc7fc81581702b734a7a4bf2f9fbfa.png";